"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerListTitle = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../common");
const SearchInput_1 = require("../ui/SearchInput");
exports.BannerListTitle = react_1.default.memo(({ searchOption, setSearchOption, }) => {
    // 대상(전체/클래스)을 편집 화면에서 고르는 등록 진입
    const onRegistBanner = () => {
        APP.eventManager.publish('CHANGE_MENU', {
            showDepth: 'regist',
            props: { isNew: true },
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.Button, { className: "btn-round btn-peach btn-xmd", text: "\uBC30\uB108 \uB4F1\uB85D", onClick: onRegistBanner }),
        react_1.default.createElement(SearchInput_1.SearchInput, { defaultValue: searchOption, setSearchOption: setSearchOption })));
});
